import { isEmpty, isEqual, isNil } from 'lodash';
import { FileUpload } from '@shared/types/fieldValues';
import { EditableField, Field } from './Field';

export class AuditTextField implements EditableField {
  readonly fieldType = 'AuditTextField';
  readonly text: string;
  readonly files: FileUpload[];
  readonly notes: string;

  constructor({ text, files, notes }: { text: string; files: FileUpload[]; notes: string }) {
    this.text = text;
    this.files = files;
    this.notes = notes;
  }

  validate(): string | null {
    return null;
  }

  isEqual(field: Field): boolean {
    return (
      field instanceof AuditTextField &&
      this.text === field.text &&
      isEqual(this.files, field.files) &&
      this.notes === field.notes
    );
  }

  toFieldJson() {
    return { text: this.text, files: this.files, notes: this.notes };
  }

  toDisplayString(): string {
    return this.text;
  }

  get isEmpty() {
    return isEmpty(this.text?.trim());
  }

  get hasData() {
    return !this.isEmpty || !isEmpty(this.files) || !isEmpty(this.notes.trim());
  }

  static fromFieldJson(json: any): AuditTextField | null {
    if (isNil(json) || typeof json !== 'object') {
      return null;
    }
    return new AuditTextField({
      text: typeof json.text === 'string' ? json.text : '',
      files: Array.isArray(json.files) ? json.files : [],
      notes: typeof json.notes === 'string' ? json.notes : '',
    });
  }
}
